import { gql } from '@apollo/client';
import TOPIC_FIELDS_FRAGMENT from './fragments/TopicFields';

export default gql`
  mutation updateTopic(
    $id: ID!
    $banner: Upload
    $unsplashId: String
    $name: String
    $description: Json
    $parentId: ID
    $privacy: TopicPrivacy
    $memberEditable: TopicMemberEditable
    $defaultSort: TopicPostsOrder
    $defaultShow: TopicPostsType
    $propagatePrivacy: Boolean
  ) {
    updateTopic(
      id: $id
      banner: $banner
      unsplashId: $unsplashId
      name: $name
      description: $description
      parentId: $parentId
      privacy: $privacy
      memberEditable: $memberEditable
      defaultSort: $defaultSort
      defaultShow: $defaultShow
      propagatePrivacy: $propagatePrivacy
    ) {
      ...TopicFields
      banner {
        original
      }
      ancestors {
        ...TopicFields
      }
      children {
        ...TopicFields
      }
    }
  }
  ${TOPIC_FIELDS_FRAGMENT}
`;
